export class Controller {

    /** @ngInject */
    constructor(Alert, EditProfileExtendedModal) {
        this.Alert = Alert;
        this.EditProfileExtendedModal = EditProfileExtendedModal;
    }

    $onInit() {
    }

    isActiveDirectory() {
        return !!this.profile.adAccountClone;
    }

    isFacebook() {
        return this.profile.profileSource === 'FACEBOOK';
    }

    showEditProfileExtendedModal() {
        this.EditProfileExtendedModal(this.profile)
            .then(profile => {
                Object.assign(this.profile, profile);
                this.Alert('success', 'registration_profiles.messages.edit');
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/extended/extended.controller.js